import { createAction } from "redux-actions";

export const LOG_LIST = "LOG_LIST";
export const logList = createAction(LOG_LIST);

export const LOG_DETAILS = "LOG_DETAILS";
export const logDetails = createAction(LOG_DETAILS);

export const DELETE_LOG = "DELETE_LOG";
export const deleteLog = createAction(DELETE_LOG);
